import styled from "styled-components";

export const CMEllipsis = styled.p(props => ({
    '& .ellipsis-tail': {
        cursor: 'pointer',
        color: props.theme.palette.blue.link,
        marginLeft: 5,

        '&:hover': {
            textDecoration: 'underline'
        }
    }
}))